import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { presetInterface } from 'src/app/util/interfaces/preset';

@Injectable({
	providedIn: 'root',
})
export class CustomPresetColumnsReportService {
	private getColumnsByType = environment.baseApiUrl + 'report/column';
	private getPresetsByType = environment.baseApiUrl + 'register/searchPreset';
	private getPresetsByID = environment.baseApiUrl + 'register/searchPreset';
	private savePreset = environment.baseApiUrl + 'register/createPreset';
	private updatePresets = environment.baseApiUrl + 'register/putPreset/{id}';
	private desactivePreset = environment.baseApiUrl + 'register/inactivePreset/{id}';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllColumnsByType(type: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<presetInterface[]>(this.getColumnsByType, {
			headers: headers,
			params: { type: type, subtype: 'general' },
		});
	}

	getPresetByType(type: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const getPresetsByTypeURL = this.getPresetsByType + '?typePreset=' + type;

		return this.httpClient.get<presetInterface[]>(getPresetsByTypeURL, {
			headers: headers,
		});
	}

	getPresetByID(id: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getPresetsByIDURL = this.getPresetsByID + '?id=' + id;
		return this.httpClient.get<presetInterface>(getPresetsByIDURL, { headers: headers }).pipe(
			map((interfaceById) => {
				interfaceById = interfaceById[0];
				const newInterface: presetInterface = {
					id: interfaceById.id,
					active: interfaceById.active,
					namePreset: interfaceById.namePreset,
					notes: interfaceById.notes,
					typePreset: interfaceById.typePreset,
					columns: interfaceById.columns,
				};
				return newInterface;
			})
		);
	}

	postPreset(preset: presetInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const body = {
			typePreset: preset.typePreset,
			namePreset: preset.namePreset,
			notes: preset.notes,
			columns: preset.columns,
		};

		return this.httpClient.post<JSON>(this.savePreset, body, { headers: headers });
	}

	putPreset(preset: presetInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		const updateLocalitysURL = this.updatePresets.replace('{id}', preset.id);

		const body = {
			typePreset: preset.typePreset,
			namePreset: preset.namePreset,
			notes: preset.notes,
			columns: preset.columns,
		};
		return this.httpClient.put(updateLocalitysURL, body, { headers: headers });
	}

	inactivePreset(id: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const desactivePresetURL = this.desactivePreset.replace('{id}', id);
		return this.httpClient.delete<any>(desactivePresetURL, { headers: headers });
	}
}
